export default __webpack_public_path__ + "static/media/syllabus_template.bc81ba05.xlsx";